// extracted by mini-css-extract-plugin
module.exports = {"container":"scoreDashboard_container__2HrdC","item":"scoreDashboard_item__1PuHd","itemValue":"scoreDashboard_itemValue__1WbVY","button":"scoreDashboard_button__2hZdK"};